import Container from "Components/Container/Container";
import React from "react";
import line from "assests/about/33.png";
const Mission = ({ data }) => {
  return (
    <section className="xl:h-[70vh] relative bg-secondary overflow-hidden">
      <div className="absolute left-0 right-0 top-[60%] -translate-y-[60%] hidden xl:block">
        <img src={line} alt="" />
      </div>
      <Container>
        <div className="xl:absolute  xl:top-1/2 xl:-translate-y-1/2 xl:w-1/3 xl:left-1/2 xl:-translate-x-1/2 py-20 xl:py-0">
          <h2 className="titles-font text-3xl text-primary capitalize xl:mb-4 xl:mt-8">
            {data?.title}
          </h2>

          <p className="" dangerouslySetInnerHTML={{ __html: data?.text }} />
        </div>
      </Container>
    </section>
  );
};

export default Mission;
